import ko from "knockout";
import BasicEmployeeStatus, {CompanyPlacement} from "./basicEmployeeStatus";
import {closePopups} from "../../../init";
import moment from "moment";
import numeral from "numeral";

class PayrollEmployeesStatusContractDetailsPopup {
    static load(item: BasicEmployeeStatus) {
        contractDetailsModel.employmentAgreementId(item.employmentAgreementId);
        contractDetailsModel.companyPlacements(item.companyPlacements.map(cp => new ContractDetailsPlacementModel(cp)));
    }
}

class ContractDetailsPopupModel {
    employmentAgreementId: KnockoutObservable<string>;
    companyPlacements: KnockoutObservableArray<ContractDetailsPlacementModel>;
    
    constructor() {
        this.employmentAgreementId = ko.observable<string>();
        this.companyPlacements = ko.observableArray<ContractDetailsPlacementModel>([]);
    }

    closePopup() {
        closePopups();
    }
}

class ContractDetailsPlacementModel {
    employeeId: KnockoutObservable<string>;
    
    companyName: KnockoutObservable<string>;
    mainBranchName: KnockoutObservable<string>;
    
    startDate: KnockoutObservable<string>;
    startDateFormatted: KnockoutObservable<string>;
    endDate: KnockoutObservable<string>;
    endDateFormatted: KnockoutObservable<string>;
    hourlyWage: KnockoutObservable<number>;
    hourlyWageFormatted: KnockoutObservable<string>;
    hoursPerWeek: KnockoutObservable<number>;
    contractType: KnockoutObservable<string>;
    
    constructor(placement: CompanyPlacement) {
        this.employeeId = ko.observable<string>(placement.employeeId);
        
        this.companyName = ko.observable<string>(placement.companyName);
        this.mainBranchName = ko.observable<string>(placement.mainBranchName);
        
        this.startDate = ko.observable<string>(placement.startDate);
        this.endDate = ko.observable<string>(placement.endDate ?? '');
        this.hourlyWage = ko.observable<number>(placement.hourlyWage);
        this.hoursPerWeek = ko.observable<number>(placement.hoursPerWeek);
        this.contractType = ko.observable<string>(placement.contractName);

        this.startDateFormatted = ko.computed<string>(() =>
            placement.startDate
                ? moment(placement.startDate).format('DD-MM-YYYY')
                : '-');

        this.endDateFormatted = ko.computed<string>(() => 
            placement.endDate
                ? moment(placement.endDate).format('DD-MM-YYYY')
                : '-');

        this.hourlyWageFormatted = ko.computed<string>(() => 
            `${numeral(placement.hourlyWage).format('$0,0.00')}/u`);
    }
    
    navigateToContract() {
        window.open(`/Admin/Employee/Contracts/${this.employeeId()}`, '_blank');
    }
}

const contractDetailsModel = new ContractDetailsPopupModel();
ko.applyBindings(contractDetailsModel, document.getElementById('contractDetails-file'));

export default PayrollEmployeesStatusContractDetailsPopup;
